if (!customElements.get("banner-logo")) {
  class BannerLogo extends HTMLElement {
    constructor() {
      super();

      this.logoWrapper = this.querySelector(".banner-logo__logo-inner");
      this.initialized = false;
    }

    connectedCallback() {
      if (!this.logoWrapper) {
        return;
      }

      this.init();
    }

    init() {
      if (!this.initialized) {
        this.logoWrapper.classList.remove("invisible");
        typeof this.logoWrapper.refreshAnimation === "function" &&
          this.logoWrapper.refreshAnimation();
        this.initialized = true;
      }
    }
  }
  customElements.define("banner-logo", BannerLogo);
}